module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-mediumitalic-webfont.c9e1c314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-mediumitalic-webfont.svg
// module id = 381
// module chunks = 3